<h1 class="text-dark text-xl" mat-dialog-title>Seleziona società</h1>
<div class="w-full" mat-dialog-content>
  <app-new-table
    [customButtons]="customButtons"
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [initialSort]="{ active: 'numeroBp', direction: 'asc' }"
  ></app-new-table>
</div>
